var Builder = {
    
    form_components : {},
    target : null,
    active_component : null,

    set_target : function(t){
        this.target = t; 
 
        if (typeof this.target.data('target') !== "undefined") {                       
            var $form_components = this.target.find('input[name="'+this.target.data('target')+'"]').val();
        }else{
            var $form_components = this.target.find('input[name="content"]').val();                        
        } 

        this.form_components = JSON.parse($form_components);
        return this;
    },
    
    populate_components : function(){
        
        var $this = this;
        if(confirm("Are you sure you want to populate the builder? All existing elements will be replaced.")=== true)  {
        
           var populate_markup = $('.populated-template-builder-list').html();
           populate_markup = populate_markup.replaceAll('template-builder-loaded','');

           $this.target.find('.target-template-builder-list').html(populate_markup);
           $('.target-template-builder-list .bbb').remove();
           $('.target-template-builder-list .modal').remove();
           
           initForm('.target-template-builder-list');

            $('.populated-template-builder-list').find('.article-component').each(function(i){
                var dd = $(this).data('component');
                dd.id = 0;
                $this.target.parent().find('.target-template-builder-list .article-component:eq('+i+')').data('component', dd);
            });

            /*var j = $('.template-builder input[name="content"]').val();
            
            $('.template-builder').each(function(){
                $this.set_target( $(this) ).commit();            
            });  

            */

        }
        
    },

    component_specific : function(comp){
        
        var $this = this,
            container = $this.target,
            all_components = container.find('.article-component');

        //
        comp.find('[data-target="#componentsModal"]').on( 'click',function($e){
            $this.active_component = $(this).closest('.article-component');
        });

        comp.find('.add-placeholder').on( 'click',function($e){
            var template = $(this).data('template');
            var target = $(this).data('target');
            var $content = $(template).html();
            var uniq = Math.floor(Math.random()* 1000000);
            var counter = 0;
            while($content.indexOf( '--unique--' )!= -1 && counter ++ < 5000){
                $content = $content.replace('--unique--' , 'partial-' + uniq );
            }
            $(target).append($content);
            initForm( target + ' .selection-item:last'  ) ;
            return false;

        });
        
        /*comp.find('.move-down').on('click',function(){
            var cont = $(this).closest('.template-builder-container');
            var pos = comp.index();
            comp.detach().insertAfter( cont.find(  '.article-component:eq('+pos+')' ) );
            $this.update_order(comp);
        });
        
        comp.find('.move-up').on('click',function(){
            var cont = $(this).closest('.template-builder-container');

            var pos = comp.index()-1;
            comp.detach().insertBefore( cont.find(  '.article-component:eq('+pos+')' ) );
            $this.update_order(comp);
        });

    */
    },


    
    update_order:function(comp){


       var all_components = this.target.find('.template-builder-container .article-component');
       if(all_components.length>0){
            
            all_components.each(function(index){
                var component = $(this);

                var d =  $(this).data('component');
                d.sort_position = index;

                $(this).data('component', d );
                /*if( all_components.length == 1){
                    $(this).find('.move-up').hide();
                    $(this).find('.move-down').hide();
                }else if(index == 0){
                    $(this).find('.move-up').hide();
                    $(this).find('.move-down').show();
                }else if(index == all_components.length - 1){
                    $(this).find('.move-up').show();
                    $(this).find('.move-down').hide();
                }else{
                    $(this).find('.move-up').show();
                    $(this).find('.move-down').show();
                }*/
            });
       }
      

    },
    apply_config : function ( caller ,$target){
        var $this = this;
        caller.closest( '.modal-config').modal('hide');
        $('.template-builder').each(function(){
              $this.set_target( $(this) ).commit();             
        });  
        this.reload_component($target);
    },
    
    reload_component : function ($base){

        var $component = $base.data('component'),
        $location_url=  $base.data('location');

        if( typeof( $component )!=='undefined' ){

            $.ajax({
             
                url : '/YHUcin15VPjgb89AWBPf/partial/'+ $component['name'] ,
                type:'POST',
                proccessData: false,
                data: {
                    scope    : 'admin',
                    url     : $location_url,
                    language  :'en',
                    component_data:  JSON.stringify($component['data']) ,
                    item_id         : typeof( $component['item_id'])!=='undefined' ?  $component['item_id']: ''
                },
                success:function(data){

                    var $mm = $(data.markup);

                    $mm.find('input').removeAttr('required').removeClass('required');
                    $mm.find('input,select').each(function(){
                        if(!$(this).hasClass('content-editable')){
                            $(this).attr('disabled' , true)
                        }
                    });
                    $mm.find('.admin-ce').each(function(){
                        $(this).addClass('content-editable').attr('contenteditable',true);
                    }); 

                    $base.find('.components-block-preview').html($mm);

                    $('.template-builder-list .way-point.fade').removeClass('fade');
                    $('.template-builder-list .way-point.animate-top').removeClass('animate-top');
                    $('.template-builder-list .way-point').removeClass('way-point');

                    $base.find('.way-point').removeClass('way-point');
                    $base.find('.fade').removeClass('fade');

                }
            });

        }
    },
   
    setup : function(){
        
        var $this = this,
            container = $this.target,
            all_components = container.find('.article-component');
       
        all_components.each(function(){
            $this.component_specific($(this));

        });

        if(container.find('.article-component:last').length> 0){
            $this.active_component = container.find('.article-component:last');
        }

        $(this.target).closest('.page-layout').find('.populate-component').on('click',function($e){

            $this.populate_components();
            return false;
        });

        $(this.target).closest('.page-layout').find('.select-template').on('click',function($e){

            var $_this = $(this),
                names = $_this.data('name').split('+');
            
            for( var i in names ){
                var n = names[i], $content = "";

                if($_this.hasClass('select-template-widget')){
                     $.ajax({ 
                        url : '/YHUcin15VPjgb89AWBPf/partial/'+$_this.data('name'),
                        data:{
                            domain:active_client.default_domain,
                            url:container.data('url')
                        },
                        success:function(data){
                            $content = $('.component-select-template[data-name="'+n+'"]').html();
                           
                            var uniq = Math.floor(Math.random()* 1000000);
                            var counter = 0;
                            while($content.indexOf( '--unique--' )!= -1 && counter ++ < 5000){
                                $content = $content.replace('--unique--' , 'partial-' + uniq );
                            }
                            var markup = $($content).attr('id', 'component-partial-'+uniq);
                            var $mm  =  $(data.markup);
                            
                            $mm.find('.admin-ce').each(function(){
                                
                                $(this).addClass('content-editable').attr('contenteditable',true);

                            }); 

                            $mm.find('input,select').attr('disabled' , true);

                            $mm.find('input,select').each(function(){
                                if(!$(this).hasClass('content-editable')){
                                    $(this).attr('disabled' , true)
                                }
                            });

                            $mm.insertAfter(markup.find('.components-block-preview'));
                           
                            if(container.find('.article-component:last').length > 0){
                                markup.insertAfter(container.find('.article-component:visible:last'));
                            }else{
                                $(container).find('.template-builder-list:visible').append(markup);
                            }

                            initForm('#component-partial-'+uniq);

                             $('#component-partial-'+uniq).data('component',{
                                id:0, name:n, data:{}
                            });

                            $this.component_specific($('#component-partial-'+uniq ));

                            setTimeout(function(){
                                
                                // START WITH 3 DUMMY IMAGES
                                $('#component-partial-'+uniq).find('.add-placeholder').trigger('click');
                                $('#component-partial-'+uniq).find('.add-placeholder').trigger('click');
                                $('#component-partial-'+uniq).find('.add-placeholder').trigger('click');

                            },10);

                            $('.template-builder-list .way-point.fade').removeClass('fade');
                            $('.template-builder-list .way-point.animate-top').removeClass('animate-top');
                            $('.template-builder-list .way-point').removeClass('way-point');

                            $('html, body').animate({
                                scrollTop: $('#component-partial-'+uniq).offset().top - $('#page-topbar').height() - 20
                            }, 1000);
                        }
                    });
                 
                 }else{

                        $content = $('.component-select-template[data-name="'+n+'"]').html();

                          var uniq = Math.floor(Math.random()* 1000000);
                            var counter = 0;
                            while($content.indexOf( '--unique--' )!= -1 && counter ++ < 5000){
                                $content = $content.replace('--unique--' , 'partial-' + uniq );
                            }
                            var markup = $($content).attr('id', 'component-partial-'+uniq);
                            if(container.find('.article-component:visible:last').length > 0){
                                markup.insertAfter(container.find('.article-component:last'));
                            }else{
                                $(container).find('.template-builder-list:visible').append(markup);
                            }

                        initForm('#component-partial-'+uniq);
                         $('#component-partial-'+uniq).data('component',{
                            id:0, name:n, data:{}
                        });

                        $this.component_specific($('#component-partial-'+uniq ));

                        setTimeout(function(){
                            // START WITH 3 DUMMY IMAGES
                            $('#component-partial-'+uniq).find('.add-placeholder').trigger('click');
                            $('#component-partial-'+uniq).find('.add-placeholder').trigger('click');
                            $('#component-partial-'+uniq).find('.add-placeholder').trigger('click');

                        },10);
                        
                 }

                $(this).closest('.modal').modal('hide');
            }

           
            $this.update_order();
            $e.preventDefault();
        });
    
        for(var i in $this.form_components){
            this.target.find('.article-component:eq('+i+')').data('component', $this.form_components[i]) ;
            this.target.find('.article-component:eq('+i+')').attr('data-component',JSON.stringify( $this.form_components[i]) );

            this.reload_component(this.target.find('.article-component:eq('+i+')'));
        }
       
         this.update_order();

 
    },


    commit : function(){

        var all_component_data = [], 
        $form = this.target;
 
        this.target.find('.article-component').each(function(index){
            
            var component = $(this);

            var compd =  $(this).data('component');
            if(typeof compd !== "undefined"){

                component.find('.content-editable').each(function(){

                    var name = $(this).data('name').split('.'), component_data = $(this).closest('.article-component').data('component');
                    if(typeof component_data === "undefined"){
                        component_data = {data:{}};
                    }

                    if( $(this).is('img') ){
                        component_data.data[ String(name[0]) ]          = $(this).attr('src');
                        component_data.data[ String(name[0]) + '_id' ]  = $(this).data('id');

                    }else if(typeof($(this).data('type'))!=='undefined' ){

                        component_data.data[ String(name[0]) ] = $(this).val();

                    }else{
                         component_data.data[ String(name[0]) ] = $(this).html();
                    }

                    if(component_data.data[ String(name[0]) ] == ''){
                        component_data.data[ String(name[0]) ] = $(this).val();
                    }

                    $(this).closest('.article-component').data('component' , component_data);
                });
 


                if(component.data('component')){

                    component_data =  $(this).data('component');
                    if(typeof component_data === "undefined"){
                        component_data = {data:{}};
                    }

                    component_data.sort_position = index + 1;

                    if(component.data('key')){

                        //component_data['data'] = {};
                        component_data['data']['images'] = [];
                        component_data['data']['images_crops'] = [];
                        component_data['data']['images_uploads'] = [];
                        component_data['data']['images_captions'] = [];

                        component.find('input[data-name="' + component.data('key')+'"]').each(function(){
                            var vv = $(this).val();
                            component_data['data']['images'].push(vv);
                        });
                        component.find('input[data-name="' + component.data('key')+'_crop"]').each(function(){
                            var vv = $(this).val();
                            component_data['data']['images_crops'].push(vv);
                        });
                        component.find('input[data-name="' + component.data('key')+'_uploader_filename"]').each(function(){
                            var vv = $(this).val();
                            component_data['data']['images_uploads'].push(vv);
                        });
                        component.find('[data-name="' + component.data('key')+'_caption"]').each(function(){
                            var vv = $(this).html();
                            component_data['data']['images_captions'].push(vv);
                        });
                    }
                    all_component_data.push(component_data);
                }
            }

        });

        if (typeof this.target.data('target') !== "undefined") {           
            $form.find('input[name="'+this.target.data('target')+'"]').val(JSON.stringify(all_component_data));
        }else{            
            $form.find('input[name="content"]').val(JSON.stringify(all_component_data));    
        }
    }
}
